const ASKED = "rally:search";

export function searchEverywhere(fragment: string): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(ASKED, { detail: fragment }));
}

export function whenSearchIsAsked(handle: (fragment: string) => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  const on = (event: Event) => handle(String((event as CustomEvent).detail ?? ""));
  window.addEventListener(ASKED, on);
  return () => window.removeEventListener(ASKED, on);
}
